import { ChangeEvent, useState } from "react";

interface LegalLinksProps {
  initialPrivacyUrl?: string;
  initialTermsUrl?: string;
}

const PRIVACY_STORAGE_KEY = "legalLinks:privacyUrl";
const TERMS_STORAGE_KEY = "legalLinks:termsUrl";

const isBrowser = typeof window !== "undefined";

export function LegalLinks({
  initialPrivacyUrl = "https://blackswan-consulting.com/privacy-policy/",
  initialTermsUrl = "https://blackswan-consulting.com/terms-and-conditions/",
}: LegalLinksProps) {
  const [privacyUrl, setPrivacyUrl] = useState(() => {
    if (!isBrowser) return initialPrivacyUrl;
    const stored = window.localStorage.getItem(PRIVACY_STORAGE_KEY);
    return stored ?? initialPrivacyUrl;
  });
  const [termsUrl, setTermsUrl] = useState(() => {
    if (!isBrowser) return initialTermsUrl;
    const stored = window.localStorage.getItem(TERMS_STORAGE_KEY);
    return stored ?? initialTermsUrl;
  });

  return (
    <>
      <a
        href={privacyUrl || "#"}
        className="transition hover:text-blue-400"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </a>
      <a
        href={termsUrl || "#"}
        className="transition hover:text-blue-400"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Service
      </a>
    </>
  );
}
